import React from 'react'
import WidgetIcon from '../../../Atoms/WidgetIcon/WidgetIcon'
import { ReactComponent as Icon } from './TreeMapWidget.Icon.svg'

export default () => <WidgetIcon icon={Icon} />
